import React, { } from "react";
import CustomTable from "../../utils/commonComponent/CustomAntTable";
import { Image } from "react-bootstrap";
import { connect } from "react-redux";
import { BaseReactComponent } from "../../utils/form";

import editIcon from '../../assets/images/edit-icon.svg'
import deleteIcon from '../../assets/images/delete-icon.svg'
import ComponentHeader from "../common/ComponentHeader";
import { API_LIMIT, AdminUsers, MODULE_ID_MAP, START_PAGE, isModuleExist } from "../../utils/Constant";
import { deleteUserApi, getUserNameApi } from "./Api";
import { InformationModal } from "../common";
import { withRouter } from "../../utils/hoc/withRouter";
import OptionsDropdown from "../../utils/commonComponent/OptionsDropdown";
class Users extends BaseReactComponent {
  constructor(props) {
    super(props);
    const AccesData = isModuleExist(MODULE_ID_MAP.AdminUsersUsers);

    this.state = {
      access: AccesData,
      firstName: "",
      lastName: "",
      search: "",
      show: false,
      dummyData: [],
      searchResult: [],
      pageSize: API_LIMIT,
      currentPage: START_PAGE,
      checkboxList: [
        {
          key: true,
          label: "On Premise Venue",
          // isDefault: false, isChecked: true,
        },
        {
          key: false,
          label: "Retail Venue",
          // isDefault: false, isChecked: false,
        },
      ],
      delete: false,
      deleteData: {},
      editData: "",
      showEdit: false,
    };
  }
  componentDidMount() {
    this.props.getUserNameApi(this);
    const { history } = this.props;
    history({
      pathname: this.props.location.pathname,
      search: `?p=${this.state.currentPage || START_PAGE}`,
    });
  }
  componentDidUpdate(prevProps, prevState) {
    const prevParams = new URLSearchParams(prevProps.location.search);
    const prevPage = parseInt(prevParams.get("page"), 10) || START_PAGE;
    const prevSize = parseInt(prevParams.get("pageSize"), 10) || API_LIMIT;

    const params = new URLSearchParams(this.props.location.search);
    const page = parseInt(params.get("page"), 10) || START_PAGE;
    const size = parseInt(params.get("pageSize"), 10) || API_LIMIT;
    // const search = params.get("search") || "";

    if (prevPage !== page || prevParams.get("search") !== params.get("search") || prevSize !== size) {
      this.setState({ currentPage: page }, () => {
        this.props.getUserNameApi(this);

      });
    }
  }
  onChangeMethod = (value) => {
    console.log(value);

  };
  getDetailsUser = (id) => {
    this.props.history({ pathname: `/user-details/${id}`, state: { "id": id } });
  }
  clearSearch = () => { };


  showEditModal = (rowData = null) => {
    this.setState({
      showEdit: !this.state.showEdit,
      editData: rowData,
    });
  };
  openCloseDeleteModal = (rowData) => {
    this.setState({
      delete: !this.state.delete,
      deleteData: rowData,
    });
  };
  deleteHandle = (id) => {
    deleteUserApi(id, this)
    this.props.getUserNameApi(this);
    // deleteAmcApi(id, this, this.openCloseDeleteModal) updat this
  }

  render() {
    const { usersList, totalPages, currentPage } = this.props.usersState;
    const { showEdit, access } = this.state;

    return (
      <>
        {this.state.delete && (
          <InformationModal
            show={this.state.delete}
            id={this.state.deleteData.uuid}
            title={`Are you sure you want to delete ${this.state.deleteData.name}?`}
            handleClose={this.openCloseDeleteModal}
            handleDelete={this.deleteHandle}
          />
        )}

        <section className="request-section">
          <ComponentHeader
            title="User"
            breadcrumb ={[["User",""]]}
            primaryBtn={access.createAccess ? "Add User" : ""}
            handlePrimaryBtn={() => {
              this.props.history("/add-user");
            }}
            // ctx={this}
          />

          <div className="commom-table-wrapper">
            <CustomTable
              data={usersList?.list || []}
              columns={[
                {
                  width: 250,
                  title: "Name",
                  dataIndex: "name",
                  className: "name",
                  isCell: true,
                  render:(text, rowData, dataKey) => {
                      return rowData.name;
                  },
                },
                {
                  width: 250,
                  title: "Email Address",
                  dataIndex: "emailAddress",
                  className: "name",
                  
                  isCell: true,
                  render:(text, rowData, dataKey) => {
                      return rowData.emailAddress;
                  },
                },

                {
                  width: 250,
                  title: "Role",
                  dataIndex: "role",
                  className: "name",
                  isCell: true,
                  render:(text, rowData, dataKey) => {
                      return rowData.role?.roleName;
                  },
                },
                {
                  width: 250,
                  title: "AMC",
                  dataIndex: "userAmc",
                  className: "name",
                  isCell: true,
                  render:(text, rowData, dataKey) => {
                      return rowData.userAmc?.map((item) => item.amc.amcName).join(',');
                  },
                },

                {
                  width: 150,
                  title: "Updated By",
                  dataIndex: "updatedBy",
                  className: "name",
                  isCell: true,
                  render:(text, rowData, dataKey) => {
                      return rowData.updatedBy?.name || 'Na';
                  },
                },
                {
                  width: 150,
                  title: "Created By",
                  dataIndex: "createdBy",
                  className: "name",
                  isCell: true,
                  render:(text, rowData, dataKey) => {
                      return rowData.createdBy?.name || 'Na';
                  },
                },
                {
                  width: 20,
                  // width: 170,
                  title: "Action",
                  dataIndex: "",
                  className: "",
                  fixed: "right",
                  isCell: true,
                  render:(text, rowData, dataKey) => {
                      return (
                        // <div className="d-flex gap-4 justify-content-around">
                        //   {access.updateAccess && (
                        //     <Image src={editIcon} className="edit-icon" onClick={() => { this.props.history({ pathname: '/edit-user', state: { editData: rowData } }) }} />
                        //   )}
                        //   {access.deleteAccess && (
                        //     <Image src={deleteIcon} className="edit-icon" onClick={() => { this.openCloseDeleteModal(rowData) }} />
                        //   )}
                        // </div>
                        <OptionsDropdown
                          editHandler={access.updateAccess ? () => { this.props.history({ pathname: '/edit-user', state: { editData: rowData } }) } : null}
                          deleteHandler={access.deleteAccess ? () => { this.openCloseDeleteModal(rowData) } : null}
                        />

                      );
                  },
                },
              ]}
              total={usersList?.length || 0}
              loading={this.state.isLoading}
            />
          </div>
        </section>
      </>
    );
  }
}


const mapStateToProps = state => ({
  usersState: state.UsersState,
});
const mapDispatchToProps = {
  getUserNameApi
  // getPosts: fetchPosts
  // getUserNameApi
};
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Users));
